/* @flow */
import React, { useRef } from 'react';
import {
  View, StyleSheet,
} from 'react-native';


const styles = StyleSheet.create({


  childrenContainer: {
    flex: 1, height: '100%', justifyContent: 'center', alignItems: 'center', padding: 40,
  },
});


const EmptyComponent = ({ children }: Object) => (

  <View style={styles.childrenContainer}>
    { children }
  </View>
);

export default EmptyComponent;
